module.exports = __webpack_public_path__ + "static/media/029.6eebb0d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/029.jpg
// module id = 376
// module chunks = 0